import type { UpdateMeterRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useUpdateMeter(
  options?: UseMutationOptions<void, unknown, UpdateMeterRequestPayload & { id: string }>,
) {
  return useMutation({
    mutationFn: async ({ id, ...newMeter }) => {
      const api = getPrivateApi();

      await api.updateMeter({
        meterId: id,
        updateMeterRequest: newMeter,
      });
    },
    ...options,
  });
}
